export interface OrderCreatorNameSource {
  creatorName?: string;
  channels?: ReadonlyArray<{ displayName?: string | null }> | null;
}

export const getOrderCreatorDisplayName = (
  order?: OrderCreatorNameSource | null,
): string | undefined => {
  const channels = Array.isArray(order?.channels) ? order.channels : [];
  const channelName = channels.length === 1 ? channels[0]?.displayName : undefined;

  return typeof channelName === "string" && channelName.trim()
    ? channelName
    : order?.creatorName;
};
